<div
  *ngIf="isImpersonating">
  <button
    data-id="stop-impersonation"
    class="impersonate-button"
    (click)="stopImpersonation()">
    Stop Impersonation
  </button>
</div>
<div
    *ngIf="!isImpersonating"
    class="impersonate-dropdown">
  <mat-select
    id="customer"
    [(ngModel)]="customer"
    (ngModelChange)="onCustomerSelected($event)"
    placeholder="Impersonate a customer"
    class="select-box"
    disableOptionCentering>
    <mat-option
        *ngFor="let customer of customers"
        [value]="customer"
        class="impersonate-dropdown-option">
      {{ customer.name }}
    </mat-option>
  </mat-select>
  <mat-select
    id="user"
    [(ngModel)]="user"
    placeholder="Impersonate a user"
    (ngModelChange)="onImpersonate($event)"
    class="select-box"
    disableOptionCentering
  >
    <mat-option
        *ngFor="let user of users"
        [value]="user"
        class="impersonate-dropdown-option">
      {{ user.firstName }} {{ user.lastName }}
    </mat-option>
  </mat-select>
</div>
